import React from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/outline';
import type { ProjectStatus } from '../types';

interface Props {
  status: ProjectStatus;
  size?: 'sm' | 'md';
}

const CONFIG: Record<ProjectStatus, { label: string; classes: string }> = {
  in_progress: {
    label: 'En cours',
    classes: 'bg-gray-100 text-gray-700 border-gray-200',
  },
  completed: {
    label: 'Complété',
    classes: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  },
  archived: {
    label: 'Archivé',
    classes: 'bg-gray-50 text-gray-600 border-gray-200',
  },
};

const StatusBadge: React.FC<Props> = ({ status, size = 'sm' }) => {
  const cfg = CONFIG[status];
  const sizeClasses = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-sm';
  return (
    <span
      className={`inline-flex items-center gap-1 ${sizeClasses} font-medium rounded-full border uppercase tracking-wide ${cfg.classes}`}
    >
      {status === 'completed' && <CheckCircleIcon className="w-3.5 h-3.5" />}
      {cfg.label}
    </span>
  );
};

export default StatusBadge;
